let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4P97l")).then(() => parcelRequire('cCtZP'));